import { useState } from "react";
import { filter, map, maxBy } from "lodash";
import { useCurrentUserLocale } from "@linkfluence/core/user/use-cases";
import { Choice, Status } from "@radarly/models/filters";

export function useWizardQueriesSelectorModal({
  options,
  onApply,
  minQueries,
}: {
  options: Array<{
    id: string;
    label: string;
    value: number;
    status: Status;
    position: number;
  }>;
  onApply: (values) => void;
  minQueries: number;
}) {
  const locale = useCurrentUserLocale();

  const [choices, setChoices] = useState(options);
  const onSelect = (choice: Choice, status: Status) => {
    const position = maxBy(choices, "position").position + 1;
    const updatedOptions = map(choices, (option) => {
      if (option.id === choice.id) {
        return { ...option, status, position };
      }
      return option;
    });
    setChoices(updatedOptions);
  };

  const onGlobalSelect = (status: Status) => {
    if (status === Status.Include) {
      return setChoices(
        map(choices, (option) => ({ ...option, status: Status.Include }))
      );
    }
    return setChoices(
      map(choices, (option) => ({ ...option, status: Status.None }))
    );
  };

  const apply = () => {
    const selectedOptions = filter(choices, { status: Status.Include });
    onApply(selectedOptions);
  };

  const isDisabled =
    filter(choices, { status: Status.Include }).length < minQueries;

  return {
    locale,
    apply,
    onGlobalSelect,
    onSelect,
    choices,
    isDisabled,
  };
}
